import { Step } from './types';

export const getStepSchema = (currentIndex: number, stepsArr: Step[]) => {
  return stepsArr[currentIndex].validationSchema;
};
